/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TreatmentPlanEmailDto
 */
export interface TreatmentPlanEmailDto {
    /**
     * Recipient email address
     * @type {string}
     * @memberof TreatmentPlanEmailDto
     */
    to: string;
    /**
     * Recipient name
     * @type {string}
     * @memberof TreatmentPlanEmailDto
     */
    name: string;
    /**
     * URL to view the treatment plan report
     * @type {string}
     * @memberof TreatmentPlanEmailDto
     */
    reportUrl: string;
}

/**
 * Check if a given object implements the TreatmentPlanEmailDto interface.
 */
export function instanceOfTreatmentPlanEmailDto(value: object): value is TreatmentPlanEmailDto {
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('reportUrl' in value) || value['reportUrl'] === undefined) return false;
    return true;
}

export function TreatmentPlanEmailDtoFromJSON(json: any): TreatmentPlanEmailDto {
    return TreatmentPlanEmailDtoFromJSONTyped(json, false);
}

export function TreatmentPlanEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TreatmentPlanEmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'to': json['to'],
        'name': json['name'],
        'reportUrl': json['reportUrl'],
    };
}

export function TreatmentPlanEmailDtoToJSON(json: any): TreatmentPlanEmailDto {
    return TreatmentPlanEmailDtoToJSONTyped(json, false);
}

export function TreatmentPlanEmailDtoToJSONTyped(value?: TreatmentPlanEmailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to': value['to'],
        'name': value['name'],
        'reportUrl': value['reportUrl'],
    };
}

